import { render, staticRenderFns } from "./ChangeMailForm.vue?vue&type=template&id=af119ffe&"
import script from "./ChangeMailForm.vue?vue&type=script&lang=ts&"
export * from "./ChangeMailForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports